// extracted by mini-css-extract-plugin
export default {"component":"nKiwL","content":"J7cRd"};